import * as React from 'react';
import { ReactSVG } from 'react-svg';
import './styles.css';
import BaseImage from '@/components/bases/BaseImage';
export interface IBaseIconSvgProps {
  src: string;
  className?: string;
  onClick?: Function;
  children?: any;
}

export default function BaseIconSvg(props: IBaseIconSvgProps) {
  const { src = '', className = '', onClick = () => {}, children, ...rest } = props;
  if (src && !src.endsWith('.svg')) {
    return (
      <BaseImage
        src={src}
        onClick={(e) => {
          onClick && onClick(e);
        }}
        className={`base-icon-svg wh-[16px] [&>div]:flex ${className} `}
        {...rest}
      />
    );
  }
  return (
    <ReactSVG
      src={src}
      onClick={(e) => {
        onClick && onClick(e);
      }}
      className={`base-icon-svg wh-[16px] [&>div]:flex ${className} `}
      {...rest}
    >
      {children}
    </ReactSVG>
  );
}

BaseIconSvg.Yellow = ({ src, className, classNameIcon, ...props }: IBaseIconSvgProps & { classNameIcon?: string }) => {
  return (
    <div className={`phr-icon-btn-yellow mr-2 ${className}`}>
      <BaseIconSvg src={src} className={`wh-[16px] ${classNameIcon}`} {...props} />
    </div>
  );
};
